import { withTranslate } from "@pathwright/ui/src/components/"
import OrderStripeCheckoutForm from "@pathwright/web/src/modules/order/OrderStripeCheckoutForm"
import PropTypes from "prop-types"

import OrderDiscountForm from "@pathwright/web/src/modules/order/OrderDiscountForm"
import { ConnectStores } from "lib/core/store"
import "./Register.css"

const Register = function (props, { school }) {
  const {
    price,
    offeringId,
    discountCode,
    invitationCode,
    useSubscriptionPlanId,
    submitLabel,
    applyDiscountCode
  } = props

  return (
    <div className="Register">
      <div style={{ padding: "0 25px" }}>
        <OrderDiscountForm applyDiscountCode={applyDiscountCode} />
        <OrderStripeCheckoutForm
          submitLabel={submitLabel}
          maintenanceModeOverride={price > 0 ? false : true}
          orderType="createRegistrationOrder"
          orderData={{
            offering_id: offeringId,
            coupon_code: discountCode,
            invitation_code: invitationCode,
            use_subscription_plan_id: useSubscriptionPlanId
          }}
        />
      </div>
    </div>
  )
}

Register.displayName = "Register"

Register.contextTypes = {
  school: PropTypes.object
}

const mapStateToProps = function (state, ownProps) {
  const { t } = ownProps

  const { invitation, offering, discount, display_price, price } =
    state.registerStore.state
  const { loadDiscount, clearRegisterErrors } = state.registerStore.action
  const { includedInUserSubscription } = state.resourceStore.request
  const { subscription } = state.subscribeStore.state

  function applyDiscountCode(code) {
    clearRegisterErrors()
    return loadDiscount(code).promise
  }

  const submitLabel =
    price > 0
      ? t("registration.register.pay_price", { display_price })
      : t("registration.register.register")

  const offeringId = offering && offering.id
  const discountCode = (discount && discount.discount_code) || undefined
  const invitationCode = (invitation && invitation.invite_token) || undefined
  const useSubscriptionPlanId =
    includedInUserSubscription(offering).length > 0
      ? subscription.school_plan.id
      : undefined

  return _.assign(
    {},
    {
      price,
      offeringId,
      discountCode,
      invitationCode,
      useSubscriptionPlanId,
      submitLabel,
      applyDiscountCode
    },
    ownProps
  )
}

const stores = [
  {
    store: "register",
    watch: ["offering", "discount", "display_price", "price", "is_registering"]
  },
  { store: "resource", watch: [] },
  { store: "subscribe", watch: [] }
]

export default withTranslate(
  ConnectStores(Register, stores, {}, mapStateToProps)
)
